import { AdvisorPartnerSuccessResponse } from '@genial/services/dist/models';

import { defaultAdvisor } from './atom';
import { MasterAdvisorProps, MasterPartnerProps } from './types';

const normalizeName = (name: string | null | undefined) => {
  if (!name) {
    return '';
  }

  return name
    .toLowerCase()
    .split(' ')
    .map((word) => (word.length === 1 ? word : word.charAt(0).toUpperCase() + word.slice(1)))
    .join(' ');
};

export const normalizeAdvisors = (
  advisors: AdvisorPartnerSuccessResponse['data']['advisor'] | null | undefined,
  partners: MasterPartnerProps[],
  isMasterPartner: boolean,
  isMasterGroup: boolean
): MasterAdvisorProps[] => {
  if (!advisors) {
    return [];
  }

  const normalizedAdvisors: MasterAdvisorProps[] = [];
  const sortedAdvisors = advisors.sort((a, b) =>
    (a.advisorName || '').localeCompare(b.advisorName || '')
  );

  for (let i = 0; i < sortedAdvisors.length; i++) {
    const advisor = sortedAdvisors[i];
    const normalizedAdvisor = {
      id: advisor.advisorId,
      name: normalizeName(advisor.advisorName),
      branchId: advisor.branchId,
      partnerId: advisor.partnerId === null ? undefined : advisor.partnerId,
      partnerName: advisor.partnerName || '',
      email: advisor.email || '',
      businessEmail: advisor.businessEmail || '',
    };

    normalizedAdvisors.push(normalizedAdvisor);
  }

  if (isMasterGroup || isMasterPartner) {
    partners?.forEach((partner) => {
      normalizedAdvisors.unshift({
        ...defaultAdvisor,
        partnerId: partner.id,
        partnerName: partner.name,
      });
    });
  }

  return normalizedAdvisors;
};

export const normalizePartners = (
  partners: AdvisorPartnerSuccessResponse['data']['partner'] | null | undefined,
  isMasterGroup: boolean
): MasterPartnerProps[] => {
  if (!partners) {
    return [];
  }

  const partnerList = partners.map((partner) => ({
    id: partner.partnerId,
    name: partner.partnerName || '',
    alias: partner.partnerAlias || '',
    branchId: partner.branchId,
    groupId: partner.groupId,
    partnerTypeId: partner.partnerTypeId,
  }));

  if (isMasterGroup) {
    partnerList.unshift({
      alias: 'Todas as Filiais',
      groupId: 0,
      branchId: 0,
      partnerTypeId: 0,
      id: 0,
      name: 'Todas as Filiais',
    });
  }

  return partnerList;
};
